import { AxiosRequestConfig } from 'axios';

const notProduction = ['local', 'dev', 'qa'].includes(
  import.meta.env.VITE_APP_ENV as string,
);

// every deployed environment the e2e suite runs against, plus local
const exposesStores = ['local', 'dev', 'qa', 'staging'].includes(
  import.meta.env.VITE_APP_ENV as string,
);

const SECONDS_PER_MINUTE = 60;
const UPLOAD_TIMEOUT_MINUTES = 5;

export const config = {
  defaultLeadChannelCode: 'CONSUMER_PORTAL',
  defaultLeadChannelCodeForCancelledApps: 'AUTOPAY_FAST_TRACK_API',
  api: {
    baseUrl:
      import.meta.env.VITE_APP_ENV === 'test'
        ? 'http://127.0.0.1:8041'
        : import.meta.env.VITE_APP_SERVICE_PUBLIC_URL,
    path: 'api',
  },
  debug: {
    devtools: notProduction,
    exposeStores: exposesStores,
  },
  unleash: {
    appName: 'consumer-portal-ui',
    clientKey: import.meta.env.VITE_APP_UNLEASH_CLIENT_KEY,
    url: import.meta.env.VITE_APP_UNLEASH_URL,
  },
  fileUploadTimeout: 30000,
  loanDocuments: {
    dropzone: {
      accept: {
        'image/jpeg': ['.jpg', '.jpeg'],
        'image/png': ['.png'],
        'application/pdf': ['.pdf'],
      },
      maxFiles: 100,
      maxSize: 25e6, // 25MB
    },
    gap: {
      exampleDocumentUrl:
        'https://ap-consumer-portal.s3.amazonaws.com/product/protection-document-examples/gap-example/gap-example-0524.pdf',
    },
    ric: {
      exampleDocumentUrl:
        'https://ap-consumer-portal.s3.amazonaws.com/product/protection-document-examples/ric-example/ric-example-0524.pdf',
    },
    signedUrlConfig: {
      timeout: 5000,
    } as AxiosRequestConfig,
    uploadConfig: {
      timeout: 1000 * SECONDS_PER_MINUTE * UPLOAD_TIMEOUT_MINUTES, // 5 minutes in milliseconds
    } as AxiosRequestConfig,
    vsc: {
      exampleDocumentUrl:
        'https://ap-consumer-portal.s3.amazonaws.com/product/protection-document-examples/vsc-example/vsc-example-0524.pdf',
    },
  },
};
